import { RegistryTable } from "../components/RegistryTable";
import { Card, EmptyState, PageHeader } from "../components/ui";
import { useCurrentOrganization } from "../lib/OrganizationContext";

const SYSTEM_TYPES = [
  "erp",
  "oms",
  "wms",
  "tms",
  "crm",
  "accounting",
  "bi",
  "pim",
  "ecommerce_platform",
  "marketplace",
  "retailer_portal",
  "edi",
  "spreadsheet",
  "database",
  "custom_app",
  "mes",
  "other",
  "unknown",
];

export function SystemsPage() {
  const { organizationId } = useCurrentOrganization();
  if (!organizationId) {
    return (
      <Card>
        <EmptyState title="No organization selected" />
      </Card>
    );
  }

  return (
    <>
      <PageHeader
        title="Systems registry"
        description="Every system the business runs on, including the spreadsheets and the unofficial ones. Upstream and downstream links come from the integration registry."
      />
      <RegistryTable
        organizationId={organizationId}
        resource="systems"
        emptyTitle="No systems discovered yet"
        emptyDescription="Systems appear here automatically as interviews name them. You can also add one directly."
        columns={[
          { key: "name", label: "System" },
          { key: "system_type_code", label: "Type" },
          { key: "vendor", label: "Vendor", kind: "text" },
          { key: "system_of_record_for", label: "System of record for" },
          { key: "status", label: "Status", kind: "status" },
          { key: "verification_status_code", label: "Verification", kind: "status" },
        ]}
        createFields={[
          { key: "name", label: "Name", required: true },
          { key: "system_type_code", label: "Type", required: true, options: SYSTEM_TYPES },
          { key: "vendor", label: "Vendor" },
          { key: "purpose", label: "Purpose" },
          { key: "url", label: "URL" },
          {
            key: "status",
            label: "Status",
            options: ["active", "legacy", "planned", "decommissioned", "unknown"],
          },
        ]}
      />
    </>
  );
}
